import React from "react"

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'

import "./clientlogos.scss"

import ImgClientLogos1 from "../../images/client-logo/hd.svg"
import ImgClientLogos2 from "../../images/client-logo/home-credit.svg"
import ImgClientLogos3 from "../../images/client-logo/koop.svg"
import ImgClientLogos4 from "../../images/client-logo/weber.svg"
import ImgClientLogos5 from "../../images/client-logo/raiffeisenbank.svg"
import ImgClientLogos6 from "../../images/client-logo/iwant.svg"
import ImgClientLogos7 from "../../images/client-logo/shoptet.svg"
import ImgClientLogos8 from "../../images/client-logo/vekra.svg"
import ImgClientLogos9 from "../../images/client-logo/t-mobile.svg"
import ImgClientLogos10 from "../../images/client-logo/toyota.svg"
import ImgClientLogos11 from "../../images/client-logo/o2.svg"
import ImgClientLogos12 from "../../images/client-logo/peugeot.svg"

const Clientlogos = (props) => (

    <div className="ftrs-clientlogos">
        <Container className="pt-5 pb-5">
            <p className="ftrs-clientlogos__intro mb-3" data-sal="fade" data-sal-duration="1000">
                {
                    props.lang === 'cs' ? "Řadu let vytváříme, udržujeme a\u00A0vylepšujeme aplikace pro\u00A0významné společnosti v\u00A0odvětví financí, pojišťovnictví, automotive, telco a\u00A0dalších. Naše produkty bývají zapojeny do\u00A0základních procesů společností a\u00A0jako takové vyžadují velmi pečlivý a\u00A0zodpovědný přístup." 
                    : props.lang === 'de' ? "Wir entwickeln, warten und\u00A0verbessern seit vielen\u00A0Jahren Apps für\u00A0mittelständische und\u00A0große Unternehmen aus\u00A0den\u00A0Bereichen Finanzen, Versicherungen, Automobil, Telekommunikation und\u00A0anderen Branchen. Unsere Produkte sind in\u00A0der\u00A0Regel in\u00A0die\u00A0grundlegenden Unternehmensprozesse eingebunden und\u00A0erfordern daher einen\u00A0sehr sorgfältigen und\u00A0verantwortungsvollen Zugang." 
                    : "For many years we have continuously created, optimized and\u00A0maintained apps for\u00A0top financial institutions, automotive, telco and\u00A0other market leaders. We\u00A0understand the\u00A0value and\u00A0impact of\u00A0our products and\u00A0therefore we strive to\u00A0deliver high-end and\u00A0bulletproof solutions."
                }
            </p>
            <Row>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos1} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos2} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos3} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos4} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos5} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos6} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos7} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos8} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos9} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos10} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos11} alt="" />
                    </div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-clientlogos__item">
                        <img loading="lazy" className="ftrs-clientlogos__img" src={ImgClientLogos12} alt="" />
                    </div>
                </Col>
            </Row>
        </Container>
    </div>

)

export default Clientlogos